// ImmunizationsCard.jsx

import React, { useState, useEffect } from "react";
import axiosInstance from "../../../axios/axios";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";
import moment from "moment";
import InjectionIcon from "../../../assets/images/Icon.svg";

const STATUS_MAP = {
  CP: { label: "Completed", statusClass: "active-status" },
  RE: { label: "Refused", statusClass: "inactive-status" },
  NA: { label: "Not Administered", statusClass: "warning-status" },
  PA: { label: "Partially Administered", statusClass: "inactive-status" },
};

const ImmunizationsCard = ({ onExportData }) => {
  const [records, setRecords] = useState([]);

  let pid = window.location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    axiosInstance
      .get("/vozo/immunization/vaccineecordslist?pid=" + pid)
      .then((response) => {
        let DecodeVal = Decrypt_Value(response.data, "vozo");

        if (DecodeVal.length > 0) {
          console.log(
            "ImmunizationsCard first record keys:",
            Object.keys(DecodeVal[0]),
          );
          console.log(
            "ImmunizationsCard first record:",
            JSON.stringify(DecodeVal[0], null, 2),
          );
        }
        setRecords(Array.isArray(DecodeVal) ? DecodeVal : []);

        if (onExportData) {
          onExportData(
            (Array.isArray(DecodeVal) ? DecodeVal : []).map((item) => ({
              vaccineName: item.recoredlist || "-",
              providerName: item.provider_name || "-",
              administeredDate: item.administered_date
                ? moment(item.administered_date).format(
                    "MMM DD, YYYY [at] h:mm A",
                  )
                : "-",
              status:
                STATUS_MAP[item.completion_status]?.label ||
                item.completion_status ||
                "-",
            })),
          );
        }
      })
      .catch((err) => {
        console.error("ImmunizationsCard error:", err);
        setRecords([]);
      });
  }, []);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <img
          src={InjectionIcon}
          className="care-summary-main-icon"
          style={{ width: "24px", height: "24px" }}
          alt="Immunizations"
        />
        <h3 className="care-summary-title">Immunizations</h3>
      </div>

      <div className="care-summary-body">
        {records
          .slice(-3)
          .reverse()
          .map((item, index, arr) => {
            const { label, statusClass } = STATUS_MAP[
              item.completion_status
            ] ?? {
              label: item.completion_status,
              statusClass: "inactive-status",
            };

            return (
              <div
                key={item.id ?? index}
                className={`care-summary-row ${
                  index !== arr.length - 1 ? "care-summary-border" : ""
                }`}
              >
                <div className="care-summary-content">
                  <div className="care-summary-heading">{item.recoredlist}</div>

                  {item.provider_name && (
                    <div className="care-summary-subtext dark-sub">
                      {item.provider_name}
                    </div>
                  )}

                  <div
                    className="care-summary-subtext"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Administered on:{" "}
                    {item.administered_date
                      ? moment(item.administered_date).format(
                          "MMM DD, YYYY [at] h:mm A",
                        )
                      : "—"}
                  </div>
                </div>

                {/* <div className={`care-summary-status-wrap ${statusClass}`}>
                  <span className="care-summary-status-dot"></span>

                  <span className="care-summary-status-text">{label}</span>
                </div> */}
                {label && (
                  <div className={`care-summary-status-wrap ${statusClass}`}>
                    <span className="care-summary-status-dot"></span>

                    <span className="care-summary-status-text">{label}</span>
                  </div>
                )}
              </div>
            );
          })}

        {records.length === 0 && (
          <div className="care-summary-subtext">
            No immunization records Added
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(ImmunizationsCard);
